exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".ms-welcome__progress {\n  padding: 20px;\n  padding-bottom: 30px;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  flex-wrap: nowrap;\n  justify-content: center;\n  align-items: center;\n}\n.ms-welcome__progress h1 {\n  margin-bottom: 80px;\n  margin-top: 30px;\n  text-align: center;\n}\n.ms-welcome__progress .ms-Spinner .ms-Spinner-label {\n  color: #999;\n}\n.ms-welcome__progress .ms-Spinner .ms-Spinner-circle {\n  color: #333333;\n  border: 1.5px solid #CCC;\n  border-top-color: #333333;\n}\n", ""]);

// exports
